import createSelectors from './createSelectors';
import Notification from '../models/Notification';

const Select = createSelectors(Notification, {});

export default Select;
